export default "__VITE_ASSET__d4086faa__"